export default "__VITE_ASSET__CT1kRhxR__"